import { render, staticRenderFns } from "./normal_fcont_118.vue?vue&type=template&id=21ddb430&"
import script from "./normal_fcont_118.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_118.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports